import React, { useState, useEffect } from 'react';
import { Button, Checkbox, Collapse, Container, FormControlLabel, Grid, TextField } from '@material-ui/core';
import { BillingAccountStatusEnum } from '../../services/V2/gozer';
import { getBacchusURL, handleError, isAdmin, remainingTime } from '../shared/Functions';
import { authProvider } from '../../services/Security';
import { Autocomplete } from '@material-ui/lab';
import { DistrictsVService, OperatorsVService } from '../../services/V2/padre';

export const BillingAccounts = (props) => {
    const [operators, setOperators] = useState<any[]>([]);
    const [operator, setOperator] = useState<any>();
    const [districts, setDistricts] = useState<any[]>([]);
    const [district, setDistrict] = useState<any>();
    const [loading, setLoading] = useState<boolean>(true);
    const [canReadOperators, setCanReadOperators] = useState<boolean>(false);
    const [canReadDistricts, setCanReadDistricts] = useState<boolean>(false);
    const [openSearch, setOpenSearch] = useState<boolean>(true);
    const [hideSearch, setHideSearch] = useState<boolean>(false);
    const [formData, setFormData] = useState<any>({
        accountNumber: "",
        firstName: "",
        lastName: "",
        email: "",
        status: "All",
        street: "",
        city: "",
        state: "",
        zip: "",
        isActive: false,
        paperBilling: false,
        disallowCC: false,
        disallowACH: false
    });
    const [resetToken, setResetToken] = useState<boolean>(false);
    const [count, setCount] = useState<number>(0);
    const url = getBacchusURL()

    window.addEventListener('message', function (e) {
        // Get the sent data
        if(!e.data) return;
        var data = JSON.parse(e.data);
        setHideSearch(data.hideSearch as boolean)
    });

    useEffect(() => {
        if(!district) return;
        loadIframe()
    }, [resetToken, district, loading])// eslint-disable-line react-hooks/exhaustive-deps

    const loadIframe = () => {
        setCount(count+1)
        authProvider.getNexusTokenFull().then(token => {
            setTimeout(() => setResetToken(!resetToken), remainingTime(token.tokenExpires))
            const frame = document.getElementById('billing-accounts') as HTMLIFrameElement;
            frame?.contentWindow?.postMessage(JSON.stringify({
                token: token,
                districtId: district?.id,
                accountNumber: formData.accountNumber,
                firstName: formData.firstName,
                lastName: formData.lastName,
                email: formData.email,
                status: formData.status === "All" ? null : formData.status,
                street: formData.street,
                city: formData.city,
                state: formData.state,
                zip: formData.zip,
                isActive: formData.isActive ? formData.isActive : null,
                paperBilling: formData.paperBilling ? formData.paperBilling : null,
                disallowCC: formData.disallowCC ? formData.disallowCC : null,
                disallowACH: formData.disallowACH ? formData.disallowACH : null,
            }), url);
        })
    }

    useEffect(() => setDistrict(props.district), [props.district])

    useEffect(() => {
        authProvider.getNexusToken().then(token => {
            let perms = authProvider.getPermissions(token);
            setCanReadOperators(perms.some((perm: string) => perm === "ReadOperator"));
            setCanReadDistricts(perms.some((perm: string) => perm === "ReadDistrict"));
        })
    }, [])

    useEffect(() => {
        if(operators.length > 0) return;
        let operatorId = authProvider.getUser()?.OperatorId;
        if(!operatorId && canReadOperators){
            OperatorsVService.operatorsVGetAll( { 
                pageNumber:  1,
                orderBy:"Name",
                orderByDesc: true,
                filters: []
                } )
                .then(o => setOperators(o.items ??[]))
                .catch(err => handleError(err));
        } else if(operatorId && canReadOperators){
            OperatorsVService.operatorsVGetById(operatorId)
                .then(o => {
                    setOperator(o);
                })
                .catch(err => handleError(err));
        }
    }, [operators, canReadOperators])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if(operator && canReadDistricts){
            DistrictsVService.districtsVGetAll(operator.id)
                .then(d => setDistricts(d.items ??[]))
                .catch(err => handleError(err));
        }
    }, [operator, canReadDistricts])// eslint-disable-line react-hooks/exhaustive-deps

    const handleReset = () => {
        setOpenSearch(true);
        setDistrict(null);
        setOperators([]);
        setOperator(null);
        setFormData({
            accountNumber: "",
            firstName: "",
            lastName: "",
            email: "",
            status: "All",
            street: "",
            city: "",
            state: "",
            zip: "",
            isActive: false,
            paperBilling: false,
            disallowCC: false,
            disallowACH: false
        })
        setLoading(!loading)
        loadIframe()
    }

    const handleChange = event => {
        let name = event.target.name;
        let value = event.target.value;
        if (event.target.type === "checkbox") {
            value = event.target.checked;
        }

        setFormData({
            ...formData,
            [name]: value
        })
    }

    return (
        <React.Fragment>
            <Container maxWidth="xl">
                {hideSearch ? null :
                    <div style={{backgroundColor: "white", borderRadius: "10px"}}>
                        <div style={{padding: '15px', margin:'0px'}}>
                            <h6 style={{textAlign: "left", fontSize:"1.25rem", letterSpacing:"0.0075em", lineHeight:"1.6"}}>Billing Accounts</h6>
                                <Collapse in={openSearch}>
                                    <div className="row col-12">
                                    {operators && !operator &&
                                        <Grid item xs={2}
                                            container={true}
                                            alignContent="flex-start">
                                            <Autocomplete
                                                value={operator || {}}
                                                id="operator"
                                                options={operators}
                                                getOptionLabel={(option) => option?.name ?? ""}
                                                renderOption={(option, { selected }) => (
                                                    <div style={{ width: "100%", textAlign:"center" }}>{option?.name}</div>
                                                )}
                                                style={{ width: 250,paddingRight: "10px", color: "#fff", textAlign:"center" }}
                                                renderInput={(params) => <TextField style={{textAlign:"center"}} {...params} label="Operator" variant="outlined" />}
                                                getOptionSelected={(o, v) => o.id === v.id}
                                                onChange={(e, o) => {
                                                        if(!operator) {
                                                            setDistrict(null);
                                                            setDistricts([]);
                                                        }
                                                        setOperator(o);
                                                    }}
                                                />
                                        </Grid>
                                    }
                                    {operator && districts &&
                                        <Grid item xs={2}
                                            container={true}
                                            alignContent="flex-start">
                                            <Autocomplete
                                                value={district || {}}
                                                id="district"
                                                options={districts}
                                                getOptionLabel={(option) => option?.name ?? ""}
                                                renderOption={(option, { selected }) => (
                                                    <div style={{ width: "100%", textAlign:"center" }}>{option?.name}</div>
                                                )}
                                                style={{ width: 300 }}
                                                renderInput={(params) => <TextField {...params} label="District" variant="outlined" required={isAdmin()} />}
                                                getOptionSelected={(o, v) => o.id === v.id}
                                                onChange={(e, d) => {
                                                        setDistrict(d);
                                                    }}
                                                />
                                        </Grid>
                                    }
                                    <Grid item xs={3}
                                        container={true}
                                        alignContent="flex-start"
                                        style={{paddingLeft: "40px"}}>
                                        <TextField
                                            onChange={handleChange}
                                            required={false}
                                            margin="normal"
                                            name="accountNumber"
                                            label="Account Number"
                                            type="text"
                                            value={formData === undefined ? null : formData.accountNumber}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={7} />
                                    <Grid item xs={2}
                                        container={true}
                                        alignContent="flex-start">
                                        <TextField
                                            onChange={handleChange}
                                            required={false}
                                            margin="normal"
                                            name="firstName"
                                            label="First Name"
                                            type="text"
                                            value={formData === undefined ? null : formData.firstName}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={2}
                                        container={true}
                                        alignContent="flex-start"
                                        style={{paddingLeft: "50px"}}>
                                        <TextField
                                            onChange={handleChange}
                                            required={false}
                                            margin="normal"
                                            name="lastName"
                                            label="Last Name"
                                            type="text"
                                            value={formData === undefined ? null : formData.lastName}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={2}
                                        container={true}
                                        alignContent="flex-start"
                                        style={{paddingLeft: "50px"}}>
                                        <TextField
                                            onChange={handleChange}
                                            required={false}
                                            margin="normal"
                                            name="email"
                                            label="Email"
                                            type="text"
                                            value={formData === undefined ? null : formData.email}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={2}
                                        container={true}
                                        alignContent="flex-start"
                                        style={{paddingLeft: "50px"}}>
                                        <TextField style={{ width: '100%', textAlign: 'left' }}
                                            select
                                            onChange={handleChange}
                                            margin="normal"
                                            name="status"
                                            label="Status"
                                            type="string"
                                            value={formData === undefined || formData.status === undefined ? "" : formData.status}
                                            >
                                                <option value="All">
                                                    All
                                                </option>
                                            {Object.keys(BillingAccountStatusEnum).sort((a,b) => a.localeCompare(b)).map(r => {
                                                return <option key={r} value={BillingAccountStatusEnum[r]}>
                                                        {BillingAccountStatusEnum[r]}
                                                    </option>
                                            })}
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={4} />
                                    <Grid item xs={2}
                                        container={true}
                                        alignContent="flex-start">
                                        <TextField
                                            onChange={handleChange}
                                            required={false}
                                            margin="normal"
                                            name="street"
                                            label="Street"
                                            type="text"
                                            value={formData === undefined ? null : formData.street}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={2}
                                        container={true}
                                        alignContent="flex-start"
                                        style={{paddingLeft: "50px"}}>
                                        <TextField
                                            onChange={handleChange}
                                            required={false}
                                            margin="normal"
                                            name="city"
                                            label="City"
                                            type="text"
                                            value={formData === undefined ? null : formData.city}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={1}
                                        container={true}
                                        alignContent="flex-start"
                                        style={{paddingLeft: "50px"}}>
                                        <TextField
                                            onChange={handleChange}
                                            required={false}
                                            margin="normal"
                                            name="state"
                                            label="State"
                                            type="text"
                                            value={formData === undefined ? null : formData.state}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={1}
                                        container={true}
                                        alignContent="flex-start"
                                        style={{paddingLeft: "50px"}}>
                                        <TextField
                                            onChange={handleChange}
                                            required={false}
                                            margin="normal"
                                            name="zip"
                                            label="Zip"
                                            type="text"
                                            value={formData === undefined ? null : formData.zip}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={6} />
                                    <Grid item xs lg={2} xl={1}
                                        container={true}
                                        alignContent="flex-start">
                                        <FormControlLabel style={{ margin:'0px' }}
                                            label="Is Active"
                                            labelPlacement="end"
                                            control={
                                                <Checkbox
                                                    checked={(formData === undefined
                                                        || formData === null || formData.isActive === undefined ? false : formData.isActive)}
                                                    onChange={handleChange}
                                                    color="primary"
                                                    name="isActive" />
                                        } />
                                    </Grid>
                                    <Grid item xs lg={2} xl={1}
                                        container={true}
                                        alignContent="flex-start">
                                        <FormControlLabel style={{ margin:'0px' }}
                                            label="Paper Billing"
                                            labelPlacement="end"
                                            control={
                                                <Checkbox
                                                    checked={(formData === undefined
                                                        || formData === null || formData.paperBilling === undefined ? false : formData.paperBilling)}
                                                    onChange={handleChange}
                                                    color="primary"
                                                    name="paperBilling" />
                                        } />
                                    </Grid>
                                    <Grid item xs lg={2} xl={1}
                                        container={true}
                                        alignContent="flex-start">
                                        <FormControlLabel style={{ margin:'0px' }}
                                            label="Disallow CC"
                                            labelPlacement="end"
                                            control={
                                                <Checkbox
                                                    checked={(formData === undefined
                                                        || formData === null || formData.disallowCC === undefined ? false : formData.disallowCC)}
                                                    onChange={handleChange}
                                                    color="primary"
                                                    name="disallowCC" />
                                        } />
                                    </Grid>
                                    <Grid item xs lg={2} xl={1}
                                        container={true}
                                        alignContent="flex-start">
                                        <FormControlLabel style={{ margin:'0px' }}
                                            label="Disallow ACH"
                                            labelPlacement="end"
                                            control={
                                                <Checkbox
                                                    checked={(formData === undefined
                                                        || formData === null || formData.disallowACH === undefined ? false : formData.disallowACH)}
                                                    onChange={handleChange}
                                                    color="primary"
                                                    name="disallowACH" />
                                        } />
                                    </Grid>
                                </div>
                            </Collapse>
                            <div className="row col-12" style={{ paddingLeft: '15px', paddingBottom: '15px', margin:'0px' }}>
                                {openSearch &&
                                    <>
                                        <Button onClick={() => {
                                            if(isAdmin() && !district) props.errorToast("District is required.")
                                            else {
                                                setLoading(!loading);
                                                setOpenSearch(false);
                                            }
                                        }} color="primary">
                                            Search
                                        </Button>
                                        <Button onClick={handleReset} style={{marginLeft: "20px"}}>
                                            Reset
                                        </Button>
                                    </>
                                }
                                {!openSearch &&
                                    <Button onClick={() => setOpenSearch(true)}>
                                        Open Search Box
                                    </Button>
                                }
                            </div>
                        </div>
                    </div>
                }
                <iframe id="billing-accounts"
                    title="billing-accounts"
                    src={`${url}/#/app/billing-accounts`}
                    width="1760px"
                    height="1100px"
                    onLoad={() => count > 1 ? null : loadIframe()}
                    style={{border: "none", display:"block"}} />
            </Container>
        </React.Fragment>
    );
}